/**
 * IRIS Design System — Chart Color Palette
 *
 * Centralised palette for ALL Recharts visuals across the application.
 * Derived from the Dashboard reference palette.
 *
 * Usage:
 *   import { CHART } from '../../constants/chartColors';
 *   <Bar fill={CHART.primary} />
 *   <Line stroke={CHART.accent} />
 */

/* ── Core data series — burgundy-anchored wine/paper palette ── */
export const CHART = {
  /** Primary burgundy — main metric, forecast bars, primary lines */
  primary: '#8B2438',
  /** Dark maroon — current-year actuals, emphasis */
  secondary: '#722F37',
  /** Tan/gold — historical, budget, secondary series (warm complement to burgundy) */
  accent: '#C9A96E',
  /** Taupe — previous-period comparisons */
  taupe: '#8B7355',
  /** Light rose — forecast portion, lighter variant of secondary */
  rose: '#B76E79',

  /* ── Semantic ── */
  success: '#16A34A',
  warning: '#CA8A04',
  danger: '#DC2626',

  /* ── Positive / Negative sentiment (bars, areas) ── */
  positive: '#16A34A',
  negative: '#DC2626',
  neutral: '#CA8A04',

  /* ── Extended palette (pie charts, stacked series) ── */
  pie: ['#722F37', '#B76E79', '#C9A96E', '#8B7355', '#8B6F8B', '#DEB5A0'] as readonly string[],

  /** Lifecycle stages */
  lifecycle: {
    NEW: '#B76E79',
    GROWTH: '#8B6F8B',
    MATURE: '#722F37',
    DECLINING: '#C9A96E',
    PHASE_OUT: '#D4A574',
    DISCONTINUED: '#9CA3AF',
  } as Record<string, string>,

  /** ABC classification */
  abc: {
    A: '#722F37',
    B: '#C9A96E',
    C: '#8B7355',
    D: '#9CA3AF',
    E: '#D1D5DB',
  } as Record<string, string>,

  /* ── Chart furniture ── */
  grid: '#EFEFEA',
  axis: '#E5E5E0',
  tick: '#8A8A85',
  labelLine: '#C4C4BF',
  tooltipBg: '#FDFBF7',
  tooltipBorder: '#E8E0D4',
} as const;
